var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "margin-bottom": "60px" } }, [
    _c(
      "div",
      { staticClass: "flex items-center justify-center title-container" },
      [
        _c("div", { staticClass: "line-left m-r-20 flex-1" }),
        _c("el-image", {
          staticStyle: { width: "47px", height: "auto" },
          attrs: { src: _vm.icon },
        }),
        _c(
          "div",
          {
            staticClass: "font-weight font-38 m-l-20 m-r-20",
            staticStyle: { color: "#A40000" },
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _c("div", { staticClass: "line-right flex-1" }),
      ],
      1
    ),
    _c("div", { staticClass: "bottom-line" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }